var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SidebarFilterBadgesContainer,{attrs:{"allFilters":_setup.props.activityTypes,"activeFilters":_vm.activeFilters,"emptyFilterLabel":_vm.$t('Keine Tätigkeit')},on:{"update:filter":(badgeFilter) => _vm.$emit('update:filter', badgeFilter)}})
}
var staticRenderFns = []

export { render, staticRenderFns }